import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { MetricBox } from 'components/UI/V3/MetricBox/MetricBox';
import React from 'react';
import styles from './MetricDelta.module.scss';

interface MetricDeltaProps {
    title: string;
    value: string;
    delta?: number;
    invertColors?: boolean;
    isLoading?: boolean;
    className?: string;
}

export const MetricDelta: React.FC<MetricDeltaProps> = props => {
    const { delta, invertColors } = props;

    const isPositive = (delta ?? 0) >= 0;
    const isGood = invertColors ? !isPositive : isPositive;

    const value = (
        <span className={styles.valueWrapper}>
            <span>{props.value}</span>
            {delta !== undefined && (
                <span className={clsx(styles.delta, isGood ? styles.deltaGood : styles.deltaBad)}>
                    <FontAwesomeIcon icon={isPositive ? faArrowUp : faArrowDown} />
                    {`${Math.abs(delta * 100).toFixed(1)}% MoM`}
                </span>
            )}
        </span>
    );

    return (
        <MetricBox
            title={props.title}
            value={value}
            isLoading={props.isLoading}
            className={clsx(styles.root, props.className)}
        />
    );
};

export default MetricDelta;
